import { getNumberItemFromStorage } from "@/scripts/Common/componentStorage";
import { ISSUER_ID_STORAGE_KEY } from "../constants";
import { fetchIssuer, fetchIssuers } from "./requests";

const fetchFirstIssuer = async () => {
  // no customer found in storage or customer does not exist anymore, load first customer from list of all customers
  const { response, error } = await fetchIssuers({ pageSize: 1 });

  return { error, response: response?.[0] };
}

// Tries to load issuer from storage if available. If not it will load the first issuer from the list of issuers
// If overrideId > 0, skips storage and loads directly by that ID
const loadIssuerFromStorageOrFirst = async (overrideId?: number) => {
  if (overrideId && overrideId > 0) {
    return fetchIssuer(overrideId);
  }

  const issuerId = getNumberItemFromStorage(ISSUER_ID_STORAGE_KEY);

  if (!issuerId) {
    return fetchFirstIssuer();
  }

  const { response, error } = await fetchIssuer(issuerId);

  return error ? fetchFirstIssuer() : { error, response };
}

export {
  loadIssuerFromStorageOrFirst
}
